import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { EmailStatus, EmailSummaryDto } from '@workspace/data-types';
import { AlertSnackBarService, LuxonDatePipe } from '@workspace/ng-aura';
import {
  EmailActionDisplayPipe,
  EmailStatusDisplayPipe,
  EmailTagDisplayPipe,
} from '@workspace/ng-data-access';
import { ApiService } from '@workspace/ng-http';
import { catchError, finalize, of, tap } from 'rxjs';
import { EmailViewerCoreComponent } from '../email-viewer/email-viewer.component';

@Component({
  selector: 'core-email-details',
  templateUrl: './email-details.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EmailActionDisplayPipe,
    EmailStatusDisplayPipe,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    EmailViewerCoreComponent,
    LuxonDatePipe,
    EmailTagDisplayPipe,
  ],
})
export class EmailDetailsCoreComponent {
  private readonly apiService = inject(ApiService);
  private readonly alertSnackBar = inject(AlertSnackBarService);
  private readonly destroyRef = inject(DestroyRef);

  email = input.required<EmailSummaryDto>();
  emailUpdated = output<EmailSummaryDto>();

  emailStatus = EmailStatus;
  isResending = signal(false);

  onResend(): void {
    if (this.isResending()) return;
    this.isResending.set(true);
    this.apiService
      .admin()
      .emails()
      .resend(this.email()._id)
      .pipe(
        tap((updatedEmail) => {
          this.alertSnackBar.success({ message: "Nouvelle tentative d'envoi effectuée !" });
          this.emailUpdated.emit(updatedEmail);
        }),
        catchError((err) => {
          this.alertSnackBar.error({
            message: "Échec du renvoi de l'e-mail : " + (err?.message || 'Erreur inconnue'),
          });
          return of(null);
        }),
        finalize(() => this.isResending.set(false)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
